import React from 'react';
import { FaSpinner } from 'react-icons/fa';
import { connect } from 'react-redux';

const Loader = (props) => {
  return props.showLoader ? (
    <div className="loader">
    <FaSpinner />
  </div>
  ) : '';
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};
const mapStateToProps = (state) => {
  return {
    showLoader: state.loaderReducer.showLoader
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Loader);
